import React from 'react';
import style from './itineraryLegs.module.scss';
import { Booking, BookingLeg, Itinerary } from 'acscp/store';
import { PageTitle } from '../common/pageTitle';
import { FormattedMessage } from 'react-intl';
import { ItineraryLeg } from './itineraryLeg';
import { ButtonRow } from '../common/buttonRow';
import { ItineraryFieldHeadings } from 'acscp/components/itinerary/itineraryFieldHeadings';
import { PrintButton } from 'acscp/components/itinerary/printButton';

interface ItineraryLegsProps {
    itinerary: Itinerary;
    bookingLegs: BookingLeg[];
    bookingDetails: Booking;
}

interface ItineraryLegsState {
    itineraryLegsShowDetails: boolean[];
}

export class ItineraryLegs extends React.Component<ItineraryLegsProps, ItineraryLegsState> {
    constructor(props: ItineraryLegsProps, context: any) {
        super(props, context);

        // Use the bookingLegs props for length array as the list is displayed mapping over the bookingLegs
        const itineraryLegsSize = this.props.bookingLegs.length;
        const itineraryLegsShowDetails = Array(itineraryLegsSize);

        if (itineraryLegsSize === 1) {
            itineraryLegsShowDetails.fill(true);
        } else {
            itineraryLegsShowDetails.fill(false);
        }

        this.state = {itineraryLegsShowDetails};
    }

    render(): JSX.Element {
        const itineraryLegs = this.props.bookingLegs.map((leg, index) => {
            const itineraryLeg = this.props.itinerary.itineraryLegs.find(il => il.leg && il.leg.id === leg.id);
            const isLastLeg = index === this.props.bookingLegs.length - 1;
            const showDetails = itineraryLeg !== undefined && this.state.itineraryLegsShowDetails[index];
            const isLongStandingCustomer = this.props.itinerary.isLongStandingCustomer;
            return (
                <>
                    <ItineraryLeg
                        itineraryLeg={itineraryLeg}
                        leg={leg}
                        legNumber={index + 1}
                        isFirstLeg={index === 0}
                        isLastLeg={isLastLeg}
                        showDetails={showDetails}
                        toggleShowDetails={() => this.toggleDetails(index)}
                        key={leg.id}
                        isLongStandingCustomer={isLongStandingCustomer}
                    />
                    {!isLastLeg && showDetails && <ItineraryFieldHeadings />}
                </>
            );
        });

        return (
            <section className={style.ItineraryPage}>
                <PageTitle
                    title={
                        <FormattedMessage
                            id={'web.components.itineraryLegs.charterItinerary'}
                            defaultMessage={'CHARTER ITINERARY'}
                        />}
                >
                    <ButtonRow className={style.HideFromPrint} bookingDetails={this.props.bookingDetails}>
                        <PrintButton />
                    </ButtonRow>
                </PageTitle>
                <ItineraryFieldHeadings bookingDetails={this.props.bookingDetails}/>
                {itineraryLegs}
            </section>
        );
    }

    toggleDetails = (existingIndex: number): void => {
        const existingItineraryLegsShowDetails = this.state.itineraryLegsShowDetails;

        const itineraryLegsShowDetails = Array(existingItineraryLegsShowDetails.length);
        existingItineraryLegsShowDetails.forEach((value, index) =>
            itineraryLegsShowDetails[index] = existingIndex === index ? !value : value);

        this.setState({itineraryLegsShowDetails});
    }
}
